// extracted by mini-css-extract-plugin
export default {"emptyCard":"styles_emptyCard__Cwqz4","text":"styles_text__YzJRH"};